import React from "react";
import { motion } from "framer-motion";
import "./style.css";
const MainHeadingText = ({
  text = "",
  direction = "left",
  about = null,
  overallDelay = 1.75,
}) => {
  const animationLeft = {
    hidden: { x: "-100vw" },
    show: {
      x: "0%",
    },
  };
  const animationRight = {
    hidden: { x: "100vw" },
    show: {
      x: "0%",
    },
  };
  const durationConfig = {
    duration: 1,
    type: "spring",
    bounce: 0.3,
    delay: 0.1,
  };
  return (
    <div className='flex justify-center '>
      {text.split("").map((letter, index) => {
        if (letter === " ") {
          return (
            <motion.p
              variants={direction === "left" ? animationLeft : animationRight}
              initial='hidden'
              animate='show'
              transition={{
                ...durationConfig,
                delay: durationConfig.delay * index + overallDelay,
              }}
              className={`text-dark dark:text-light ${
                about ? "heading-super-about" : "heading-super"
              } font-bold `}
            >
              &nbsp;
            </motion.p>
          );
        }
        return (
          <motion.p
            variants={direction === "left" ? animationLeft : animationRight}
            initial='hidden'
            animate='show'
            transition={{
              ...durationConfig,
              delay: durationConfig.delay * index + overallDelay,
            }}
            className={`text-dark dark:text-light ${
              about ? "heading-super-about" : "heading-super"
            } font-bold `}
          >
            {letter}
          </motion.p>
        );
      })}
    </div>
  );
};

export default MainHeadingText;
